import { Link, Navigate, Route, Routes } from 'react-router-dom'

import { AppLayout } from '#components/AppLayout.js'
import { RequireAuth } from '#components/RequireAuth.js'
import { AccountsView } from '#features/accounts/AccountsView'
import { CarrierConnectionsView } from '#features/carrierConnections/CarrierConnectionsView.js'
import { CarriersView } from '#features/carriers/CarriersView.js'
import { DocumentReportsView } from '#features/documents/DocumentReportsView'
import { DocumentsView } from '#features/documents/DocumentsView'
import { EbolView } from '#features/ebol/EbolView'
import { DocumentLookupsView } from '#features/getDocuments/DocumentLookupsView'
import { GetTrackingsView } from '#features/getTrackings/GetTrackingsView'
import { Login } from '#features/login/Login'
import { ProfinderLogsView } from '#features/profinder/ProfinderLogsView'
import { QuotesReport } from '#features/quotes/QuotesReport'
import { QuoteView } from '#features/quotes/QuoteView'
import { CarrierRequestsReport } from '#features/reports/CarrierRequestsReport.js'
import { ProFinderReport } from '#features/reports/ProFinderReport'
import { UnmappedErrorsReport } from '#features/reports/UnmappedErrorsReport'
import { TenantsView } from '#features/tenants/TenantsView'
import { TendersView } from '#features/tenders/TendersView'
import { TracesView } from '#features/traces/TracesView'
import { TrackingReportsView } from '#features/trackings/TrackingReportsView'
import { TrackingsView } from '#features/trackings/TrackingsView'
import { UnmappedTrackEventsReport } from '#features/trackings/UnmappedTrackEventsReport'

const NotFound = () => (
  <div className="rounded-box border border-base-300 bg-base-100 p-10 text-center">
    <h2 className="text-xl font-semibold">Page not found</h2>
    <p className="mt-2 text-sm opacity-70">
      The route you requested does not exist. Choose a tab from the sidebar.
    </p>
    <Link className="btn btn-primary mt-4" to="/accounts">
      Back to Accounts
    </Link>
  </div>
)

export const AppRoutes = () => (
  <Routes>
    <Route path="/login" element={<Login />} />
    <Route element={<RequireAuth />}>
      <Route path="/carriers/:layer?" element={<CarriersView />} />
      <Route element={<AppLayout />}>
        <Route index element={<Navigate to="/accounts" replace />} />
        <Route path="/accounts" element={<AccountsView />} />
        <Route path="/tenants" element={<TenantsView />} />
        <Route
          path="/carrier-connections"
          element={<CarrierConnectionsView />}
        />
        <Route path="/quotes" element={<QuoteView />} />
        <Route path="/ebol" element={<EbolView />} />
        <Route path="/tenders" element={<TendersView />} />
        <Route path="/tracking" element={<TrackingsView />} />
        <Route path="/documents" element={<DocumentsView />} />
        <Route path="/get-trackings" element={<GetTrackingsView />} />
        <Route path="/get-documents" element={<DocumentLookupsView />} />
        <Route path="/profinder" element={<ProfinderLogsView />} />
        <Route path="/traces" element={<TracesView />} />

        <Route path="/tracking-reports" element={<TrackingReportsView />} />
        <Route path="/documents-reports" element={<DocumentReportsView />} />
        <Route
          path="/carrier-requests-report"
          element={<CarrierRequestsReport />}
        />
        <Route
          path="/tracking-unmapped"
          element={<UnmappedTrackEventsReport />}
        />
        <Route path="/unmapped-errors" element={<UnmappedErrorsReport />} />
        <Route path="/quotes-report" element={<QuotesReport />} />
        <Route path="/profinder-report" element={<ProFinderReport />} />

        <Route path="*" element={<NotFound />} />
      </Route>
    </Route>
  </Routes>
)
